// Route preloading utility - triggers dynamic imports on hover
const pageImports: Record<string, () => Promise<unknown>> = {
  '/pricing': () => import('@/pages/Pricing'),
  '/about': () => import('@/pages/About'),
  '/features': () => import('@/pages/HomeExperimental'),
  '/help': () => import('@/pages/HelpCenter'),
  '/academy': () => import('@/pages/Academy'),
  '/blog': () => import('@/pages/Blog'),
  '/faq': () => import('@/pages/FAQ'),
  '/free-marketing': () => import('@/pages/FreeMarketing'),
  '/ai': () => import('@/pages/AIPlatform'),
  '/done-for-you': () => import('@/pages/DoneForYou'),
  '/agency-owners': () => import('@/pages/AgencyOwners'),
  '/platform-demos': () => import('@/pages/PlatformDemos'),
};

// Cache to prevent re-importing already loaded pages
const preloadedRoutes = new Set<string>();

export const preloadRoute = (path: string) => {
  // Skip if already preloaded
  if (preloadedRoutes.has(path)) return;
  
  const importer = pageImports[path];
  if (importer) {
    preloadedRoutes.add(path);
    importer();
  }
};

export default preloadRoute;
